import { use } from 'react';

import {
  CheckoutContext,
  CheckoutProvider,
  Product,
} from '../../contexts/checkout.context';

import './Checkout.styles.scss';

const Cart = () => {
  const { cartItems, addToCart, removeFromCart, decrementCartItem } =
    use(CheckoutContext);

  const cartCount = cartItems.reduce((acc, cur) => (acc += cur.quantity), 0);

  const cartTotal = cartItems.reduce(
    (acc, cur) => (acc += cur.quantity * cur.price),
    0,
  );

  return (
    <div className="checkout-cart">
      <h2>Cart</h2>
      {cartItems?.length ? (
        <>
          <table>
            <thead>
              <tr>
                <th className="color-block" />
                <th>Name</th>
                <th className="align-right">Qty</th>
                <th className="align-right">Price</th>
                <th className="align-right">Subtotal</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item) => (
                <tr key={`cart-row-${item.id}`}>
                  <td className="color-block">
                    <div style={{ backgroundColor: item.color }} />
                  </td>
                  <td>{item.name}</td>
                  <td className="align-right">{item.quantity}</td>
                  <td className="align-right">{`@ $${item.price}`}</td>
                  <td className="align-right">{`$${
                    item.quantity * item.price
                  }`}</td>
                  <td>
                    <button type="button" onClick={() => addToCart(item)}>
                      +
                    </button>
                    <button
                      type="button"
                      onClick={() => decrementCartItem(item)}
                    >
                      -
                    </button>
                    <button type="button" onClick={() => removeFromCart(item)}>
                      X
                    </button>
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan={2}>Total</td>
                <td className="align-right">{cartCount}</td>
                <td colSpan={2} className="align-right">{`$${cartTotal}`}</td>
                <td />
              </tr>
            </tbody>
          </table>
        </>
      ) : (
        <div>Cart is empty</div>
      )}
    </div>
  );
};

const Products = () => {
  const PRODUCTS: Product[] = [
    {
      id: 1,
      name: 'Tiamat',
      price: 25,
      color: 'red',
    },
    {
      id: 2,
      name: 'Bahamut',
      price: 50,
      color: 'green',
    },
    {
      id: 3,
      name: 'Frezoor',
      price: 35,
      color: 'blue',
    },
  ];

  const {
    addToCart,
    // removeFromCart,
    // decrementCartItem.
  } = use(CheckoutContext);
  return (
    <div className="checkout-products">
      <h2>Products</h2>
      {PRODUCTS.map((product) => (
        <div className="checkout-product" key={`product-${product.id}`}>
          <span
            className="product-color-block"
            style={{ backgroundColor: product.color }}
          />
          <span>{`${product.name} - $${product.price}`}</span>
          <button type="button" onClick={() => addToCart(product)}>
            Add to Cart
          </button>
        </div>
      ))}
    </div>
  );
};

const Checkout = () => (
  <CheckoutProvider>
    <div id="checkout-content" role="main">
      <h1>Checkout Page</h1>
      <Cart />
      <Products />
    </div>
  </CheckoutProvider>
);

export default Checkout;
